module.exports = __webpack_public_path__ + "img/464077.8a1f18d4.jpg";